export default {
    _source :null,
    _targets: null,

    init() {
        this._source = document.querySelectorAll('[data-source]');
        this._targets = document.querySelectorAll('[data-source-target]');

        if (!(this._source.length)) {
            return;
        }
            
        for (const src of this._source) {
            src.addEventListener(('click'), () => {
                const srcClass = src.classList[0]+'--active';

                for (const btn of this._source) {
                    btn.classList.remove(srcClass);
                }
                for(const target of this._targets){
                    const targetClass= target.classList[0]+'--active';
                    if(src.getAttribute('data-source') == "all"){
                        target.classList.add(targetClass);
                        src.classList.add(srcClass);
                    }else{
                        let empCats = JSON.parse(target.getAttribute('data-source-target'));
                        if(empCats.includes(src.getAttribute('data-source'))){
                            target.classList.add(targetClass);
                            src.classList.add(srcClass);
                        }else{
                            target.classList.remove(targetClass);
                        }
                    }
                }
            });
        }
    }
}
